import { useState, useEffect } from 'react'

import { getSalesFunnelList } from '@user/store/salesFunnel/api'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'

export const useGetSalesFunnelListOnMount = (
  includeCounts: boolean = false,
) => {
  const dispatch = useAppDispatch()
  const [status, setStatus] = useState<'pending' | 'success' | 'fail'>(
    'pending',
  )

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        const result = await dispatch(getSalesFunnelList(includeCounts))

        if (mounted) {
          if (getSalesFunnelList.fulfilled.match(result)) setStatus('success')
          else setStatus('fail')
        }
      } catch (error) {
        if (mounted) {
          setStatus('fail')
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch, includeCounts])

  return status
}
